import React from "react";

const Gametitle = () => {
  return <div className="title">Rock Paper Scissors</div>;
};

export default Gametitle;
